// §12 / §19.1 — driver rating dashboard client. Both routes are gated by
// ORD_DN_MNG on the BE (delivery-management tier, same as POD review).
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IDeliveryRating {
  id: string
  deliveryNoteId: string
  businessId: string
  buyerBusinessId: string | null
  buyerUserId: string | null
  driverUserId: string
  rating: number
  comment: string | null
  categories: Record<string, number> | null
  ratedAt: string
}

export interface IDriverRatingSummary {
  driverUserId: string
  totalRatings: number
  averageRating: number
  // BE returns numeric keys 1..5; JSON serialises them as strings, but JS
  // object access by number or string is equivalent here.
  starsBreakdown: Record<number, number>
  categories: Record<string, { average: number; count: number }>
}

export interface IDriverRatingsResponse {
  rows: IDeliveryRating[]
  count: number
}

export const getDriverSummary = async (driverUserId: string): Promise<IDriverRatingSummary> => {
  return httpRequest.get(`/ord/driver/${driverUserId}/rating-summary`)
}

export const getDriverRatings = async (
  driverUserId: string,
  offset?: { limit: number; skip: number },
): Promise<IDriverRatingsResponse> => {
  return httpRequest.get(
    `/ord/driver/${driverUserId}/ratings`,
    offset ? { limit: offset.limit, skip: offset.skip } : undefined,
  )
}
